import { Field, ObjectType } from '@nestjs/graphql'
import { IdDto } from './idDto'

@ObjectType()
export class BaseModelWithoutUserDto extends IdDto {
  @Field()
  createdDate!: Date

  @Field({ nullable: true })
  updatedDate?: Date
}
